const SET_SELECTED_COMMITTEE = 'SET_SELECTED_COMMITTEE';
const SET_SELECTED_SUB_COMMITTEE = 'SET_SELECTED_SUB_COMMITTEE';
const SET_SELECTED_MEMBER = 'SET_SELECTED_MEMBER';

export default {
    SET_SELECTED_COMMITTEE,
    SET_SELECTED_SUB_COMMITTEE,
    SET_SELECTED_MEMBER
}